import React, { useEffect, useState } from 'react'
import CustomTable from '../../../../Components/Table/CustomTable'
// import BannerinputGetModal from '../../Modal/BannerModal/BannerinputGetModaldal';
import { Grid } from '@mui/material';
// import BannerinputGetModal from '../../../CommonModal/BannerModal/BannerinputGetModal';
import { useDispatch, useSelector } from 'react-redux';
import actions from '../../../../ReduxStore/actions';
import { toast } from 'react-toastify';
import '../../../../Components/ModalCss/BannerinputGetModal.css';
// import LandingPage from '../../Preview/LandingPage';
import PreviewComponent from '../../PreviewComponent/PreviewComponent';
import BannerinputGetModal from '../Modal/Banner/BannerinputGetModal';
import BlogMainPage from '../BlogsPreview/Banner/BlogMainPage';
import { setHeaderName, setSubHeaderName } from '../../../../ReduxStore/Slices/headerSlice';
// import ReferralsMainPage from '../ReferralsContentPreview/Banner/ReferralsMainPage';

const BannerSection = () => {

    const permissions = JSON.parse(sessionStorage.getItem("permissions"));
    // const permissions = JSON.parse(sessionStorage.getItem("permissions"));
    const role = sessionStorage.getItem("role")
    // csonole

    // const tableData = role === "superAdmin"
    //   ? [{ title: 'The Best Gold', secondtext: 'Staking Company', subtext: 'Lorem Ipsum is simply dummy text of the...', documents: "banner.jpg" }]
    //   : [];

    const tableHeadData = role === "superAdmin" || role === "management"
        ? ['S.No', 'Title', 'Second Text', 'Sub Text', 'Creater Name', "Creater Role", "Approver Name", "Approver Role", "Rejector Name", "Rejector Role", "status"]
        : ['S.No', 'Title', 'Second Text', 'Sub Text', 'status']





    const dispatch = useDispatch();

    const [responseTableData, setResponseTableData] = useState([])
    // const permissions = JSON.parse(sessionStorage.getItem("permissions"));
    console.log(responseTableData, "responseTableDataresponseTableData")
    const { getBlogSectionById } = useSelector(state => state?.getBlogSectionById);
    const { addBlogSection } = useSelector(state => state?.addBlogSection);

    const { updateBlogSection } = useSelector(
        (state) => state?.updateBlogSection
    );

    const { deleteBlogSection } = useSelector(
        (state) => state?.deleteBlogSection
    );




    const { getAllBlogSectionsWithCreatorBySectionName } = useSelector(
        (state) => state?.getAllBlogSectionsWithCreatorBySectionName
    );

    const { getAllBlogSectionsBySectionNameBasedOnCreator } = useSelector(
        (state) => state?.getAllBlogSectionsBySectionNameBasedOnCreator
    );

    const [rowTableData, setRowTableData] = useState([])
    console.log(rowTableData, "rowTableTAdatatattattat")
    console.log(getAllBlogSectionsBySectionNameBasedOnCreator, "rowTableTAdatatattattat111111")

    const { addBlogSectionWithApproval } = useSelector(
        (state) => state?.addBlogSectionWithApproval
    );




    const { updateBlogSectionForReApproval } = useSelector(
        (state) => state?.updateBlogSectionForReApproval
    );


    const { approveBlogSection } = useSelector((state) => state?.approveBlogSection);
    const { rejectBlogSection } = useSelector((state) => state?.rejectBlogSection);


    useEffect(() => {
        dispatch(setHeaderName("Content Management"));
        dispatch(setSubHeaderName("Blogs"));
    }, []);


    useEffect(() => {
        const fetchData = async () => {
            if (role === "superAdmin" || role === "management") {

                const data1 = {
                    data: {

                        section_name: "banner" // "Touch" , "getInTouch"
                    },
                    method: "post",
                    apiName: `getAllBlogSectionsBySectionNameWithAllAuthUserDetails`,
                };

                const responseData = await dispatch(actions.GETALLBLOGSECTIONSWITHCREATORBYSECTIONNAME(data1));
                setResponseTableData(responseData?.payload)

            }

            else {

                const data1 = {
                    data: {
                        section_name: "banner" // "Touch" , "getInTouch"

                    },
                    method: "post",
                    apiName: `getAllBlogSectionsBySectionNameBasedOnCreator`,
                };

                const responseData = await dispatch(actions.GETALLBLOGSECTIONSBYSECTIONNAMEBASEDONCREATOR(data1));
                setResponseTableData(responseData?.payload)


            }
        }


        fetchData();
    }, [addBlogSection, approveBlogSection, rejectBlogSection, addBlogSectionWithApproval, deleteBlogSection, updateBlogSection, updateBlogSectionForReApproval]);

    useEffect(() => {
        const tempArr = [];
        if (role === "superAdmin" || role === "management") {
            getAllBlogSectionsWithCreatorBySectionName?.data?.map((data, index) => {
                return tempArr.push({

                    title: data?.heading || '--',
                    secondtext: data?.sub_heading || '--',
                    subtext: data?.content || '--',
                    section_id: data?.section_id || '--',
                    // approval_status: data?.approval_status || "--"
                    creatorName: data?.creator?.name || '--',
                    creatorRole: data?.creatorRole?.roleName || '--',
                    approverName: data?.approver?.name || '--',
                    approverRole: data?.approverRole?.roleName || '--',
                    rejectorName: data?.rejector?.name || '--',
                    rejectorRole: data?.rejectorRole?.roleName || '--',
                    approval_status: data?.approval_status
                        ? data.approval_status.charAt(0).toUpperCase() + data.approval_status.slice(1)
                        : "--"
                });
            });
            setRowTableData(tempArr);
        } else {
            getAllBlogSectionsBySectionNameBasedOnCreator?.data?.map((data, index) => {
                return tempArr.push({

                    title: data?.heading || '--',
                    secondtext: data?.sub_heading || '--',
                    subtext: data?.content || '--',
                    section_id: data?.section_id || '--',
                    // approval_status: data?.approval_status || "--"
                    approval_status: data?.approval_status
                        ? data.approval_status.charAt(0).toUpperCase() + data.approval_status.slice(1)
                        : "--"

                });
            });
            setRowTableData(tempArr);

        }
    }, [getAllBlogSectionsBySectionNameBasedOnCreator, getAllBlogSectionsWithCreatorBySectionName]);


    console.log(rowTableData, "rowTableDatattattata")


    const handleTableDataDelete = async (id) => {


        const data1 = {
            data: {},
            method: "delete",
            apiName: `deleteBlogSection/${id}`,
        };
        const responseData = await dispatch(actions.DELETEBLOGSECTION(data1));
        if (responseData?.payload?.message === "Blog section soft deleted successfully.") {
            toast.success(responseData?.payload?.message)
        } else {
            toast.error(responseData?.payload?.message)

        }
    }


    return (
        <Grid container spacing={2}>

            <Grid item xs={12} sx={{ width: "100px" }}>

                <CustomTable
                    // tableEdit="tableEdit"
                    // tableDelete="tableDelete"

                    tableData={rowTableData} title="Banner" tableHeadData={tableHeadData}
                    //   modalName={BannerinputGetModal}
                    //   editModalName={BannerinputGetModal}


                    // const permissions = JSON.parse(sessionStorage.getItem("permissions"));
                    tableView={true}
                    modalVeiwName={PreviewComponent}
                    ModalPreviewComponent1={BlogMainPage}

                    handleTableDataDelete={handleTableDataDelete}
                    sectionNameForApproveAndReject="BlogSection"


                    tableDelete={permissions?.ContentManagement?.Blog?.delete}
                    tableEdit={permissions?.ContentManagement?.Blog?.edit}
                    dataCreate={permissions?.ContentManagement?.Blog?.add}
                    //   apiBasedName="stakeNowBannerInputModal"
                    //   tableData={rowTableData}
                    //   title="Banner"
                    //   tableHeadData={tableHeadData}
                    modalName={BannerinputGetModal}
                    editModalName={BannerinputGetModal}
                //   handleTableDataDelete={handleTableDataDelete}

                />

            </Grid>
        </Grid>
    )
}

export default BannerSection